import { Fragment, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { isTeadsUI } from 'src/i18n';
import { useHistory } from 'src/lib/hooks/useHistory';

import { ROUTES } from '../../routes';

import { SignUpPage } from './SignUpPage';

const Container = () => {
  const history = useHistory();

  useEffect(() => {
    if (isTeadsUI()) {
      history.replace(ROUTES.SIGN_IN);
    }
  }, [history]);

  return (
    <Fragment>
      <Helmet>
        <title>Sign up</title>
      </Helmet>
      <SignUpPage />
    </Fragment>
  );
};

export default Container;
